import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SessionKeys, clickStreamUser, getStepIndex } from "../../utils/AppUtils";
import _ from "lodash"
import CONFIG from "../../utils/config";
import { setJoyRideReq } from "../../redux/assignCourse/actions";

const RolePlayTabSection = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const key = params.get('key');
    const username = params.get('username');
    const user_id = params.get('user_id');
    const color_1 = params.get('color_1');
    const color_2 = params.get('color_2');
    const role = params.get('role');

    const authBroker = useSelector(state => state.auth.authBroker)
    const [roleArray, setRoleArray] = useState([])
    const [mobileURL, setMobileURL] = useState('')

    const userRole = useSelector((state) => state.user.role);
    const isPremiumUser = useSelector(state => state.user.isPremiumUser);


    useEffect(() => {
        if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" && !_.isEmpty(authBroker)) {
            // const isGuest = authBroker.payload.user.role.includes('guest')
            // const stepIndex = getStepIndex('#idParticipationSummary', userRole, isPremiumUser, isGuest);
            // // dispatch(setJoyRideReq({ run: true, stepIndex: (userRole === 'manager' ? isPremiumUser ? 18 : 19 : isPremiumUser ? 17 : 8) }))
            // dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            setRoleArray(authBroker.payload.user.role)
        }
    }, [authBroker])

    useEffect(() => {
        if (props.isMobile) {
            let URL = `color_1=${color_1}&color_2=${color_2}&username=${username}&user_id=${user_id}&role=${role}&key=${key}&token=${token}`
            console.log(URL)
            setMobileURL(URL)
        }
    }, [props.isMobile])


    const redirectTo = (page) => {

        switch (page) {
            case 'role-play':
                clickStreamUser('participate-roleplay-tab-clicked', {
                    user_id: authBroker?.payload.user?.user_id
                })
                props.isMobile ?
                    navigate(`/role-play-mobile?${mobileURL}`) :
                    navigate('/role-play')
                break;
            case 'review':
                clickStreamUser('review-tab-clicked', {
                    user_id: authBroker?.payload.user?.user_id
                })

                props.isMobile ?
                    navigate(`/review-role-play-mobile?${mobileURL}`) :
                    navigate('/review-role-play')
                break;
            case 'my-roleplay':
            default:
                clickStreamUser('my-roleplay-tab-clicked', {
                    user_id: authBroker?.payload.user?.user_id
                })
                props.isMobile ?
                    navigate(`/my-role-play-mobile?${mobileURL}`) :
                    navigate('/my-role-plays')
                break;
        }

    }

    return (
        <>
            <section className="secrpmailtab">
                <div className="roleplaypagetabsec">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="xseltabsnav d-flex justify-content-start">
                                    {/* <button 
                                className={`btn-primary ${props.page === 'participate' ? 'active-page' : ''}`}
                                onClick={() => {
                                    if (props.page != 'participate') {
                                        redirectTo('role-play')
                                    }
                                }}
                                >
                                    Record a New Role play
                                </button> */}
                                    <button
                                        id="idParticipationSummary"
                                        className={`tabroleplay ${props.page === 'roleplay' ? 'active-page' : ''}`}
                                        onClick={() => {
                                            if (props.page != 'roleplay') {
                                                redirectTo('my-roleplay')
                                            }
                                        }}
                                    >
                                        {/* My Role play */}
                                        My Participation Summary
                                    </button>
                                    {roleArray.includes('coach') || sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" ? <button
                                        id="idCoachingSummary"
                                        className={`tabroleplay ${props.page === 'review' ? 'active-page' : ''}`}
                                        onClick={() => {
                                            redirectTo('review')

                                        }}
                                    >
                                        {/* For You to Review */}
                                        My Coaching Summary
                                    </button> : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="sepratortabbtm"></span>
            </section>
        </>
    )
}

export default RolePlayTabSection;